import axios from '@/clientAPI.ts'
import {
    CitiesResponseType,
    CountriesResponseType,
    CountriesWithLanguageResponseType,
    LanguagesResponseType,
    LanguagesResponseTypeV3,
    RegionsResponseType
} from '../types'
import {
    CitiesResponseSchema,
    CountriesResponseSchema,
    CountriesWithLanguageResponseSchema,
    LanguagesResponseSchema,
    RegionsResponseSchema
} from './country.schema'
import axiosV3 from '@/clientAPIV3.ts'

export const COUNTRY_API = {
    getRegions: async ({countryId}: {countryId: number | string}): Promise<RegionsResponseType> => {
        const params = {
            country_id: countryId,
            response_type: 'extended'
        }
        const url = `/regions`
        const {data} = await axios.get(url, {params})
        return RegionsResponseSchema.parse(data)
    },
    getCities: async ({countryId}: {countryId: number | string}): Promise<CitiesResponseType> => {
        const params = {
            country_id: countryId,
            response_type: 'extended'
        }
        const url = `/cities`
        const {data} = await axios.get(url, {params})
        return CitiesResponseSchema.parse(data)
    },
    getFilterCountries: async (): Promise<CountriesWithLanguageResponseType> => {
        const params = {
            response_type: 'extended'
        }
        const url = `/countries/filters`
        const {data} = await axios.get(url, {params})
        return CountriesWithLanguageResponseSchema.parse(data)
    },
    getLanguages: async ({is_translatable}: {is_translatable: boolean}): Promise<LanguagesResponseType> => {
        const url = `/languages`
        const {data} = await axios.get(url, {
            params: {is_translatable}
        })
        return LanguagesResponseSchema.parse(data)
    },
    getFilterLanguages: async (): Promise<LanguagesResponseType> => {
        const params = {
            response_type: 'extended'
        }
        const url = `/languages/filters`
        const {data} = await axios.get(url, {params})
        return LanguagesResponseSchema.parse(data)
    }
}

export const getLanguagesV3 = async ({isTranslatable}: {isTranslatable: boolean}): Promise<LanguagesResponseTypeV3> => {
    const {data} = await axiosV3.get(`/languages`, {params: {isTranslatable}})
    return data
}

export const getCountriesV3 = async (): Promise<CountriesResponseType> => {
    const url = `/countries`
    const {data} = await axiosV3.get(url)
    return CountriesResponseSchema.parse(data)
}
